import React from 'react';
import {shopContext} from '../../context/shop-context';
import { useContext } from 'react';
function Product(props) {
    const {AddToCart,cartValue}=useContext(shopContext);
    const CartItems=cartValue[props.data.id];
  return (
    <div className='product'>
        <img src={props.data.ProductImg} alt="" />
        <div className="description">
            <p>{props.data.ProductName}</p>
            <p>${props.data.Price}</p>
        </div>
        <button className='AddToCartBtn' onClick={()=>{AddToCart(props.data.id)}}>Add to cart {CartItems>0 && <>({CartItems})</>}</button>
    </div>
  )
}

export default Product;
